import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component (ResourceBooking) code-splits
// into its own tpl-resource-booking chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'resource-booking',
    name: 'Resource Booking',
    description: 'An interface to allow booking of resources like rooms, seats and services',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-resource-booking" */ "./ResourceBooking")),
    canDragDropFields: true,
    icon: ['fas', 'credit-card-blank'],
    complexity: 'advanced',
    autoHieght: true,
});
